/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2022-12-22 20:17:41
 */
import React, { memo, useEffect, useMemo } from 'react'
import ContactUS from '../components/ContactUS'
import sensors from '../../utils/sensors'

interface RebindMobileProps {
  reason: string
  onClick?: () => void
}

const RebindMobile = ({ reason, onClick = () => {} }: RebindMobileProps) => {
  const title = useMemo(() => {
    return reason === 'noAccount' ? '未创建今日水印相机账号' : '未创建团队'
  }, [reason])

  useEffect(() => {
    sensors.track('web_show_workgroup_login_bind_phone_error', {
      pageType: reason,
      actionType: 'show'
    })
  }, [reason])

  const subtitle = useMemo(() => {
    return reason === 'noAccount'
      ? '或在APP创建账号后再绑定'
      : '或在APP创建团队后再来体验'
  }, [reason])

  return (
    <div className="panel">
      <div className="rebinding">
        <div className="title">该手机号</div>

        <div className="title">{title}</div>

        <div
          className="btn"
          onClick={() => {
            sensors.track('web_show_workgroup_login_bind_phone_error', {
              pageType: reason,
              actionType: 'clickChangenum'
            })

            onClick()
          }}
        >
          更换手机号
        </div>

        <div className="subtitle">{subtitle}</div>

        <div className="contact-us">
          <ContactUS
            fromPage="更换绑定手机号"
            track={() => {
              sensors.track('web_show_workgroup_login_bind_phone_error', {
                pageType: reason,
                actionType: 'clickContactUs'
              })
            }}
          >
            <a>联系客服</a>
          </ContactUS>
        </div>
      </div>
    </div>
  )
}

export default memo(RebindMobile)
